<template>
  <BannerHomeComponent />
  <ServicesComponent />
  <ContactComponent />
  <AppointmentModal />
</template>
<script>
import BannerHomeComponent from "../components/BannerHomeComponent";
import ServicesComponent from "../components/ServicesComponent";
import ContactComponent from "../components/ContactComponent";
import AppointmentModal from "../components/AppointmentModal";

export default {
  name: "HomePage",
  components: {
    ContactComponent,
    ServicesComponent,
    BannerHomeComponent,
    AppointmentModal,
  },
};
</script>
